var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "project-mobile-gallery mobile-gallery-slick-slider mt-3",
      attrs: { id: "gallery" },
    },
    [
      _c(
        "div",
        { staticClass: "mobile-gallery-slick-slider-list draggable" },
        _vm._l(_vm.images, function (image, index) {
          return _c("div", { staticClass: "mobile-gallery-item" }, [
            _c(
              "div",
              {
                staticClass:
                  "mobile-gallery-image-container d-flex justify-content-center align-items-center",
                on: {
                  click: function ($event) {
                    return _vm.onShowModalGallery(index, true)
                  },
                },
              },
              [
                _c("img", {
                  attrs: { "data-lazy": image.webImage },
                  on: { load: _vm.loaded },
                }),
              ]
            ),
          ])
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }